module.exports = __webpack_public_path__ + "static/media/logo.fb52b079.png";